export default "__VITE_ASSET__BOM87qJF__"